<template>
 <div class="expert-community-container">
  <div class="expert-community-post-component">
   <!-- Left Section - Posts -->
   <div class="community-post">
    <div class="post-item" v-for="(post, index) in posts" :key="index">
     <div class="post-details">
      <div class="flex-space-between" style="align-items: flex-start">
       <div class="expert-info">
        <span @click="goToExpertStore(post)">
         <img class="expert-photo" v-if="post.profile_details.profile_pic" :src="post.profile_details.profile_pic" />
         <img class="expert-photo" v-else src="../assets/images/navBar/avatar.jpg" />
        </span>
        <div class="expert-meta">
         <div class="name-and-verify" v-if="post.profile_details">
          <h4 class="expert-name capitalize">{{ post.profile_details.full_name }}</h4>
          <el-tooltip v-if="post.profile_details.profession == 'Official StockAnts Representative'" class="item" effect="dark" content="Official StockAnts Representative" placement="top">
           <img class="info-Logo cursor-pointer" src="../assets/images/stockantsVerifiedAdmin.png" style="width: 16px" alt />
          </el-tooltip>
          <el-tooltip v-else-if="post.profile_details.is_active_ra" class="item" effect="dark" content="Verified SEBI registered Expert" placement="top">
           <img class="info-Logo cursor-pointer" src="../assets/images/verify.svg" style="width: 16px" alt />
          </el-tooltip>
         </div>

         <p class="expert-profession" v-if="post.profile_details.profession == 'Official StockAnts Representative'" style="color: #2d2e8d">{{ post.profile_details.profession ? post.profile_details.profession : '' }}</p>
         <p class="expert-profession" v-else>{{ post.profile_details.profession ? post.profile_details.profession : '' }}</p>
         <p class="timestamp">{{ post.created_at ? moment(post.created_at).format('MMM DD, YYYY, h:mm A') : '' }}</p>
        </div>
       </div>
       <div class="edit-section">
        <el-button type="success" class="chat-btn right-margin-10" v-if="$router.currentRoute.path == '/expert-buzz' && post.profile_details.is_active_ra" @click="$router.push('/expert-list')">
         <img src="../assets/images/chat.svg" alt="" style="width: 16px" />
         <span style="position: relative; bottom: 2px; margin-left: 5px">Chat</span>
        </el-button>
        <span v-if="$router.currentRoute.path == '/my-posts' || ($router.currentRoute.path == '/expert-buzz' && (userProfile.id == 26306 || userProfile.id == 26583 || userProfile.id == 40723))" style="position: relative; top: 1px; left: 4px">
         <el-popover placement="bottom" trigger="click" style="margin-bottom: 4px" @show="handlePopoverShow">
          <div class="editPopover">
           <div v-if="$router.currentRoute.path == '/my-posts'">
            <div @click="openEditMode(post, index)" class="flex cursor-pointer title" style="color: black">
             <img src="@/assets/images/SACommunity/Edit (1).svg" class="right-margin-10" width="18px" alt="" />
             Edit Post
            </div>

            <div class="flex top-margin-10 cursor-pointer title" style="color: black" @click="deletePost(post.id, index)">
             <img src="@/assets/images/SACommunity/Delete.svg" class="right-margin-10" width="18px" alt="" />
             Delete Post
            </div>
           </div>
           <div v-else>
            <div v-if="!isEditLikeShareActive">
             <div class="flex cursor-pointer title" style="color: black" @click="enableEditSection('Like')">
              <img src="@/assets/images/SACommunity/Like.svg" class="right-margin-10" width="18px" alt="" />
              Edit Likes
             </div>

             <div class="flex top-margin-10 cursor-pointer title" style="color: black" @click="enableEditSection('Share')">
              <img src="@/assets/images/SACommunity/Share.png" class="right-margin-10" width="18px" alt="" />
              Edit Share
             </div>

             <div class="flex top-margin-10 cursor-pointer title" style="color: black" @click="deletePost(post.id, index)">
              <img src="@/assets/images/SACommunity/Delete.svg" class="right-margin-10" width="18px" alt="" />
              Delete Post
             </div>
            </div>
            <div v-if="isEditLikeShareActive && post.analytics">
             <div v-if="activeEdit == 'Like'">
              <el-input type="number" placeholder="Enter Number" style="width: 120px" size="mini" v-model="post.analytics.total_likes"></el-input>
             </div>
             <div v-if="activeEdit == 'Share'">
              <el-input type="number" placeholder="Enter Number" style="width: 120px" size="mini" v-model="post.analytics.total_shares"></el-input>
             </div>

             <el-button class="save-btn" size="mini" @click="editLikeShareCount(post.id, post.analytics.total_likes, post.analytics.total_shares)">Save Changes</el-button>

             <div></div>
            </div>
           </div>
          </div>
          <i class="el-icon-more cursor-pointer" slot="reference"></i>
         </el-popover>
        </span>
       </div>
      </div>
      <p class="post-text" v-html="formattedPost(post.post)"></p>
      <div class="post-media" v-if="post.attachments && post.attachments.length">
       <div class="carousel community-carousel" v-if="post.attachments && post.attachments.length > 1">
        <el-carousel :interval="3000" indicator-position="outside" autoplay>
         <el-carousel-item v-for="(item, index) in post.attachments" :key="index">
          <img :src="item" class="carousel-image" />
         </el-carousel-item>
        </el-carousel>
       </div>
       <div class="carousel community-carousel" v-else>
        <img :src="post.attachments[0]" class="carousel-image" />
       </div>
      </div>
      <div class="post-actions">
       <div>
        <div class="action activated" v-if="post.profile_details.login_user_status.isliked" @click="addLikeShareAction(post.id, 'unlike', index)">
         <img src="@/assets/images/SACommunity/activeLike.png" style="position: relative; top: -2px" alt="" />
         Like {{ post.analytics.total_likes ? convertValue(post.analytics.total_likes) : '' }}
        </div>
        <div class="action" v-else>
         <img src="@/assets/images/SACommunity/Like.svg" style="position: relative; top: -2px" alt="" @click="addLikeShareAction(post.id, 'like', index)" />
         Like {{ post.analytics.total_likes ? convertValue(post.analytics.total_likes) : '' }}
        </div>
       </div>
       <div>
        <div class="action activated" v-if="post.profile_details.login_user_status.isshared">
         <el-popover placement="bottom" trigger="click" style="margin-bottom: 4px" @show="handlePopoverShow">
          <div class="editPopover">
           <div class="flex cursor-pointer title" style="color: black" @click="copyToClipboard(post.id)">
            <img src="@/assets/images/SACommunity/link.png" class="right-margin-10 copy-share-icons" alt="" />
            Copy Link To Share
           </div>

           <div class="flex top-margin-10 title" style="color: black" @click="">
            <img src="@/assets/images/SACommunity/shareIcon2.png" class="copy-share-icons right-margin-10" alt="" />
            Share Via
           </div>

           <div class="flex-space-around top-margin-15">
            <img class="social-icons" src="../assets/images/whatsapp.png" alt="" @click="shareOn('whatsapp', post.id)" />
            <img class="social-icons" src="../assets/images/telegram.svg" alt="" @click="shareOn('telegram', post.id)" />
            <img class="social-icons" src="../assets/images/facebook.png" alt="" @click="shareOn('facebook', post.id)" />
            <img class="social-icons" src="../assets/images/linkedin.png" alt="" @click="shareOn('linkedin', post.id)" />
           </div>
          </div>
          <img src="@/assets/images/SACommunity/activeShare.png" slot="reference" alt="" />
         </el-popover>
         <span style="position: relative; bottom: 6px">Share {{ post.analytics.total_shares ? convertValue(post.analytics.total_shares) : '' }}</span>
        </div>
        <div class="action" v-else>
         <el-popover placement="bottom" trigger="click" style="margin-bottom: 4px" @show="handlePopoverShow">
          <div class="editPopover">
           <div class="flex cursor-pointer title" style="color: black" @click="copyToClipboard(post.id)">
            <img src="@/assets/images/SACommunity/link.png" class="right-margin-10 copy-share-icons" alt="" />
            Copy Link To Share
           </div>

           <div class="flex top-margin-10 title" style="color: black" @click="">
            <img src="@/assets/images/SACommunity/shareIcon2.png" class="copy-share-icons right-margin-10" alt="" />
            Share Via
           </div>

           <div class="flex-space-around top-margin-15">
            <img class="social-icons" src="../assets/images/whatsapp.png" alt="" @click="shareOn('whatsapp', post.id)" />
            <img class="social-icons" src="../assets/images/telegram.svg" alt="" @click="shareOn('telegram', post.id)" />
            <img class="social-icons" src="../assets/images/facebook.png" alt="" @click="shareOn('facebook', post.id)" />
            <img class="social-icons" src="../assets/images/linkedin.png" alt="" @click="shareOn('linkedin', post.id)" />
           </div>
          </div>
          <img src="@/assets/images/SACommunity/Share.png" slot="reference" alt="" @click="addLikeShareAction(post.id, 'share', index)" />
         </el-popover>
         <span style="position: relative; bottom: 6px">Share {{ post.analytics.total_shares ? convertValue(post.analytics.total_shares) : '' }}</span>
        </div>
       </div>
      </div>
     </div>
    </div>
   </div>
  </div>

  <el-dialog :visible.sync="isEditing" @close="closeEditMode" class="edit-post-dialog" width="600px" :close-on-click-modal="true" v-if="Object.keys(selectedPostForEdit).length">
   <div class="dialog-body">
    <div class="expert-info">
     <img class="expert-photo" :src="serverHostName + selectedPostForEdit.profile_details.profile_pic" alt="" />
     <div class="expert-details">
      <div class="expert-name">{{ selectedPostForEdit.profile_details.full_name }}</div>
      <div class="expert-profession">{{ selectedPostForEdit.profile_details.profession }}</div>
     </div>
    </div>

    <!-- Post Content Input -->
    <el-input type="textarea" v-model="selectedPostForEdit.post" placeholder="Edit your post content" rows="5" class="rounded-input" />
   </div>

   <!-- Footer Buttons -->
   <span slot="footer" class="dialog-footer">
    <el-button class="save-btn" @click="editPost(selectedPostForEdit.id)">Save</el-button>
   </span>
  </el-dialog>

  <div class="stock-profile-dialog">
   <el-dialog :visible.sync="isStockProfilePopupVisible" :show-close="false" :before-close="clearTradingViewWidget">
    <div class="tradingview-widget-container" ref="tradingviewContainer"></div>
   </el-dialog>
  </div>
 </div>
</template>

<script>
import { serverAddr, serverHostName } from '../networkConfig';
import CripNotice from 'crip-vue-notice';
import moment from 'moment';

export default {
 name: 'ExpertCommunityPost',
 mixins: [],
 components: {},
 props: {
  posts: {
   type: Array,
   required: true,
  },
 },
 data() {
  return {
   moment: moment,
   isEditLikeShareActive: false,
   activeEdit: '',
   serverHostName: serverHostName,
   isEditing: false,
   editedPostContent: '',
   selectedPostForEdit: {},
   isStockProfilePopupVisible: false,
  };
 },
 mounted() {
  document.addEventListener('click', this.handleStockClick);
 },

 methods: {
  handleStockClick(e) {
   const target = e.target;
   if (target.classList.contains('stock-link')) {
    const symbol = target.getAttribute('data-symbol');
    if (symbol) {
     this.loadTradingViewWidget(symbol);
    }
   }
  },
  loadTradingViewWidget(symbol) {
   this.isStockProfilePopupVisible = true;

   this.$nextTick(() => {
    this.loadTradingViewWidgetContent(symbol);
   });
  },

  loadTradingViewWidgetContent(symbol) {
   const container = this.$refs.tradingviewContainer;
   if (!container) {
    console.error('TradingView container not found');
    return;
   }

   // Clear previous content
   container.innerHTML = '';

   // Create required DOM structure
   const widgetDiv = document.createElement('div');
   widgetDiv.className = 'tradingview-widget-container__widget';

   const copyright = document.createElement('div');
   copyright.className = 'tradingview-widget-copyright';
   copyright.innerHTML = `<a href="https://www.tradingview.com/" rel="noopener nofollow" target="_blank">
      <span class="blue-text">Track all markets on TradingView</span></a>`;

   const script = document.createElement('script');
   script.type = 'text/javascript';
   script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-symbol-profile.js';
   script.async = true;

   // This is the magic part — JSON as text inside script tag
   script.text = JSON.stringify({
    width: '100%',
    height: '450',
    isTransparent: false,
    colorTheme: 'light',
    symbol: `BSE:${symbol}`,
    locale: 'en',
   });

   // Append elements in correct order
   container.appendChild(widgetDiv);
   container.appendChild(copyright);
   container.appendChild(script);
  },

  clearTradingViewWidget(done) {
   const container = this.$refs.tradingviewContainer;
   if (container) {
    container.innerHTML = '';
   }
   done();
  },
  formattedPost(text) {
   if (!text) return '';
   return text.replace(/\n/g, '<br>').replace(/@(\w+)/g, (match, stockSymbol) => {
    return `<span class="external-link-color stock-link" data-symbol="${stockSymbol}">@${stockSymbol}</span>`;
   });
  },
  copyToClipboard(postId) {
   const pageUrl = window.location.origin + `/expert-buzz?post_id=${postId}`;

   navigator.clipboard
    .writeText(pageUrl)
    .then(() => {
     // Set isCopied to true to display the "Text Copied!" message
     new CripNotice({
      title: 'Success',
      description: 'Link Copied!',
      type: 'success',
      duration: 3,
     });
    })
    .catch((err) => console.error('Unable to copy text to clipboard', err));

   // Simulate a click outside to close popover
   document.body.click();
  },

  shareOn(platform, postId) {
   // `/expert-buzz?post_id=${postId}`

   var pageUrl = window.location.origin + `/expert-buzz?post_id=${postId}`;
   var message = encodeURIComponent('Check this out!');

   var isMobile = window.innerWidth <= 768;

   let shareUrl = '';

   switch (platform) {
    case 'whatsapp':
     shareUrl = isMobile ? `whatsapp://send?text=${message}%20${pageUrl}` : `https://web.whatsapp.com/send?text=${message}%20${pageUrl}`;
     break;

    case 'telegram':
     shareUrl = isMobile ? `tg://msg?text=${message}%20${pageUrl}` : `https://t.me/share/url?url=${pageUrl}&text=${message}`;
     break;

    case 'facebook':
     shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${pageUrl}`;
     break;

    case 'linkedin':
     shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${pageUrl}`;
     break;
   }

   if (shareUrl) {
    window.open(shareUrl, '_blank');
   }

   // Simulate a click outside to close popover
   document.body.click();
  },

  //  Below code for Edit post
  openEditMode(post, index) {
   this.editedPostContent = post.post; // Fill the content of the post into the editor
   this.isEditing = true; // Show the edit modal
   this.selectedPostForEdit = post; // Store the post to be edited
   this.selectedPostForEdit.index = index;

   console.log(this.selectedPostForEdit);
  },

  // Close the edit modal
  closeEditMode() {
   this.isEditing = false;
  },

  // Function to handle the edit post API request
  editPost(postId) {
   const updatedPostData = {
    post: this.selectedPostForEdit.post,
   };

   serverAddr
    .patch(`/community/edit/community-post/${postId}`, updatedPostData)
    .then((response) => {
     if (response.data.status) {
      this.isEditing = false; // Close the editing mode
      this.$set(this.posts[this.selectedPostForEdit.index], this.selectedPostForEdit);
      new CripNotice({
       title: 'Success',
       description: 'Post updated successfully!',
       type: 'success',
       duration: 3,
      });
     } else {
      // Handle case where update fails
      new CripNotice({
       title: 'Error',
       description: 'Failed to update post.',
       type: 'error',
       duration: 3,
      });
     }
    })
    .catch((error) => {
     console.log(error);
     new CripNotice({
      title: 'Error',
      description: 'An error occurred while updating the post.',
      type: 'error',
      duration: 3,
     });
    })
    .finally(() => {
     document.body.click(); // Close any modals or popups if needed
    });
  },

  deletePost(postId, index) {
   //  /delete/community-post/44' \
   serverAddr
    .delete(`/community/delete/community-post/${postId}`)
    .then((response) => {
     if (response.data.status) {
      this.posts.splice(index, 1);
      new CripNotice({
       title: 'Success',
       description: 'Post deleted successfully!',
       type: 'success',
       duration: 3,
      });
     } else {
     }
    })
    .catch(
     function (error) {
      console.log(error);
     }.bind(this)
    )
    .finally(() => {
     document.body.click();
    });
  },
  handlePopoverShow() {
   this.isEditLikeShareActive = false;
   this.activeEdit = '';
  },
  convertValue(count) {
   const num = parseInt(count, 10); // Remove leading zeros
   const rounded = Math.floor(num / 100) / 10; // Round to 1 decimal place
   return num >= 1000 ? `${rounded}K` : num.toString();
  },
  addLikeShareAction(postId, action, index) {
   serverAddr
    .post('/community/post_action', {
     post_id: postId,
     action: action,
    })
    .then((response) => {
     if (response.data.status) {
      if (action == 'like') {
       this.$set(this.posts[index].profile_details.login_user_status, 'isliked', true);
       this.$set(this.posts[index].analytics, 'total_likes', this.posts[index].analytics.total_likes + 1);
      } else if (action == 'unlike') {
       this.$set(this.posts[index].profile_details.login_user_status, 'isliked', false);
       this.$set(this.posts[index].analytics, 'total_likes', this.posts[index].analytics.total_likes - 1);
      } else if (action == 'share') {
       this.$set(this.posts[index].profile_details.login_user_status, 'isshared', true);
       this.$set(this.posts[index].analytics, 'total_shares', this.posts[index].analytics.total_shares + 1);
      }
     } else {
     }
    })
    .catch(
     function (error) {
      console.log(error);
     }.bind(this)
    );
  },
  enableEditSection(currentAction) {
   this.activeEdit = currentAction;
   this.isEditLikeShareActive = true;
  },
  editLikeShareCount(postId, likes, share) {
   serverAddr
    .post('/community/post_action', {
     post_id: postId,
     action: 'manual_override',
     manual_like: Number(likes),
     manual_share: Number(share),
    })
    .then((response) => {
     if (response.data.status) {
      new CripNotice({
       title: 'Success',
       description: 'Changes saved successfully!',
       type: 'success',
       duration: 3,
      });
     }
    })
    .catch(
     function (error) {
      console.log(error);
     }.bind(this)
    )
    .finally(() => {
     document.body.click();
     this.activeEdit = '';
     this.isEditLikeShareActive = false;
    });
  },

  goToExpertStore(post) {
  // console.log('expert object:', post);
  // console.log('user_id:', post.profile_details.user_id);
  // console.log('full_name:', post.profile_details.full_name);

  this.$store.commit('commitExpertDetails', {}); 

  this.$router.push({
    path: '/expert-store',
    query: {
      user_id: post.profile_details.user_id,
      user: 'individual',
      name: post.profile_details.full_name,
    },
  });
}

 },
 computed: {
  userProfile() {
   return JSON.parse(localStorage.getItem('profile'));
  },
 },

 beforeDestroy() {
  document.removeEventListener('click', this.handleStockClick);
 },
};
</script>

<style scoped lang="scss">
.expert-community-post-component {
 display: flex;
 box-sizing: border-box;

 .community-post {
  width: 100%;

  .post-item {
   margin-bottom: 30px;

   .post-details {
    background-color: #fff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);

    .expert-info {
     display: flex;
     align-items: flex-start;

     .expert-photo {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      object-fit: cover;
      margin-right: 15px;
     }

     .expert-meta {
      .name-and-verify {
       display: flex;
       gap: 5px;
       align-items: center;
      }

      .expert-name {
       margin: 0;
       font-size: 15px;
       font-weight: 600;
       color: #000000;
      }

      .expert-profession,
      .timestamp {
       font-size: 12px;
       font-weight: 500;
       color: #a9a9a9;
       margin: 2px 0;
      }
     }
    }
    .chat-btn {
     font-size: 12px;
     padding: 7px 10px 5px;
     background-color: #fff;
     color: #2488ff;
     border: 0.5px solid #2488ff;
     border-radius: 50px;
     font-weight: 600;
    }
    .post-text {
     font-size: 13px;
     font-weight: 500;
     color: #000000;
     margin: 15px 0;
    }

    .post-media {
     margin-bottom: 15px;

     //  img {
     //   max-width: 100%;
     //   height: 100%;
     //   display: block;
     //   border-radius: 8px;
     //  }
    }

    .post-actions {
     display: flex;
     gap: 20px;

     .action {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #333;
      font-weight: 500;

      img {
       cursor: pointer;
       width: 18px;
       height: 18px;
       margin-right: 5px;
      }

      i {
       margin-right: 6px;
       font-size: 18px;
      }

      &:hover {
       color: #409eff;
      }
     }
     .activated {
      color: #409eff;
     }
    }
   }
  }
 }

 @media (max-width: 768px) {
  .community-post {
   .post-item {
    margin-bottom: 18px;
   }
  }
 }
}
</style>
<style lang="scss">
.community-carousel {
 height: 350px !important;

 .el-carousel__container {
  height: 335px !important;
 }

 .carousel-image {
  max-width: 100%;
  height: 300px !important;
  display: block;
  border-radius: 20px !important;
  margin: 0 auto;
 }
 .el-carousel__item.is-active {
  z-index: 1;
 }
}
.el-popover {
 min-width: 95px;
 .editPopover {
  img {
   width: 18px;
  }
  .copy-share-icons {
   width: 14px;
   padding: 5px;
   background-color: #eff5fe !important;
   border-radius: 50%;
  }
  .social-icons {
   width: 25px;
   cursor: pointer;
  }
  .save-btn {
   width: 120px;
   background: linear-gradient(90deg, #2d2e8d 0%, #0c0d27 100%);
   color: #ffff;
   font-weight: 600;
   border-radius: 6px;
   font-size: 12px;
   padding: 8px;
  }

  .el-input__inner {
   background-color: #f5f5f5;
   margin-bottom: 15px;
  }
 }
}
.edit-post-dialog {
 .el-dialog {
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
 }

 .el-dialog__header {
  padding: 0px;
 }
 .el-dialog__body {
  padding: 0px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
 }
 .dialog-body {
  padding: 20px;

  .rounded-input {
   .el-textarea__inner {
    border-radius: 8px;
    font-size: 14px;
    line-height: 1.5;
    padding: 10px;
    border: 1px solid #dcdfe6;
    transition: border-color 0.3s;

    &:focus {
     border-color: #409eff;
    }
   }
  }

  .section-title {
   font-weight: 600;
   font-size: 15px;
   margin-top: 20px;
   margin-bottom: 10px;
   color: #303133;
  }
 }

 .dialog-footer {
  padding: 10px 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  .el-button {
   border-radius: 6px;
   background-color: #2d2e8d;
   color: #ffff;
  }
 }
 .expert-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
 }

 .expert-photo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
 }

 .expert-details {
  display: flex;
  flex-direction: column;
 }

 .expert-name {
  font-weight: 600;
  font-size: 15px;
 }

 .expert-profession {
  font-size: 12px;
  color: #888;
 }

 @media screen and (max-width: 800px) {
  .el-dialog {
   width: 95vw !important;
   margin: 10px auto !important;
  }

  .dialog-body {
   padding: 16px;
  }

  .expert-info {
   display: inline-flex;
   align-items: center;
   gap: 12px;
   flex-wrap: wrap;
  }

  .expert-photo {
   width: 30px;
   height: 30px;
  }

  .expert-name {
   font-size: 14px;
  }

  .expert-profession {
   font-size: 11px;
  }

  .dialog-footer {
   flex-direction: column;
   align-items: stretch;

   .el-button {
    width: 100%;
    margin-top: 10px;
   }
  }
 }
}

.expert-community-container {
 .stock-profile-dialog {
  .el-dialog {
   margin-top: 100px;
   width: 400px;
   border-radius: 8px;
  }

  .el-dialog__body,
  .el-dialog__header {
   padding: 0px;
  }

  .el-dialog__headerbtn .el-dialog__close {
   z-index: 2;
   position: relative;
  }

  .box-card {
   border-radius: 10px !important;
   border: none;
   box-shadow: none;
  }

  .box-card-two {
   margin: 5px;
  }

  .el-checkbox__inner {
   border-radius: 4px;
  }
 }

 @media screen and (max-width: 600px) {
  .stock-profile-dialog {
   .el-dialog {
    margin-top: 20px;
    width: 95%;
   }
  }
 }
}
</style>